import { defineComponent, computed } from "vue";
import SvgIcon from "./base/SvgIcon.vue.mjs";
import { useRoomStore } from "../../stores/room.mjs";
import { storeToRefs } from "pinia";
import { isUndefined } from "../../utils/utils.mjs";
import MicOnIcon from "./icons/MicOnIcon.vue.mjs";
import MicOffIcon from "./icons/MicOffIcon.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AudioIcon",
  props: {
    userId: null,
    audioVolume: null,
    isMuted: { type: Boolean },
    size: null,
    isDisabled: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const roomStore = useRoomStore();
    const { userVolumeObj } = storeToRefs(roomStore);
    const currentAudioVolume = computed(() => {
      if (!isUndefined(props.audioVolume)) {
        return props.audioVolume;
      }
      if (userVolumeObj.value && props.userId) {
        return userVolumeObj.value[props.userId];
      }
      return 0;
    });
    const icon = computed(() => props.isMuted ? MicOffIcon : MicOnIcon);
    const audioLevelStyle = computed(() => {
      if (props.isMuted || !currentAudioVolume.value) {
        return "";
      }
      return `height: ${currentAudioVolume.value * 4}%`;
    });
    return { __sfc: true, roomStore, userVolumeObj, currentAudioVolume, props, icon, audioLevelStyle, SvgIcon };
  }
});
export {
  _sfc_main as default
};
